import React, { useState, useEffect } from 'react';
import EmployeeProcessService from "../services/EmployeeProcessService";
import { useLoading } from '../Utils/LoadingContext';

const ShiftAllocation = () => {
    const [plantList, setPlantList] = useState([]);
    const [selectedPlant, setSelectedPlant] = useState('');
    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState('');

    const [employees, setEmployees] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [shiftList, setShiftList] = useState([]);
    const [selectedShift, setSelectedShift] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selectAll, setSelectAll] = useState(false);
    const [showHistory, setShowHistory] = useState(false);
    const [historyData, setHistoryData] = useState([]);
    const [historyEmpCode, setHistoryEmpCode] = useState('');
    const { setLoading } = useLoading();
    const empcode = localStorage.getItem('empcode');

    // ✅ new search field
    const [searchCode, setSearchCode] = useState('');

    const [filters, setFilters] = useState({
        PlantName: "",
        DepartmentName: "",
        EmployeeCode: "",
        Mode:""
    });

    useEffect(() => {
        loadPlants();
    }, []);

    const loadPlants = async () => {
        try {
            const plantRes = await EmployeeProcessService.getPlant(empcode);
            if (plantRes?.data?.statusCode === 200) {
                setPlantList(plantRes.data.result);
            }
        } catch (error) {
            console.error("Error loading plants:", error);
        }
    };

    const handlePlantChange = async (e) => {
        const plantId = e.target.value;
        setSelectedPlant(plantId);

        setEmployees([]);
        setSelectedEmployees([]);
        setSelectAll(false);
        setShiftList([]);
        setSelectedShift('');
        setDepartments([]);
        setSelectedDepartment('');

        if (!plantId) return;

        try {
            debugger;
            // ✅ Fetch departments bound to Plant + empcode
            const deptRes = await EmployeeProcessService.getDepartment(empcode, plantId);
            if (deptRes.data.statusCode === 200) {
                setDepartments(deptRes.data.result);
            }

            // ✅ Fetch shifts bound to Plant
            const shiftRes = await EmployeeProcessService.getShift(plantId);
            if (shiftRes.data.statusCode === 200) {
                setShiftList(shiftRes.data.result);
            }
        } catch (error) {
            console.error("Failed to load plant data:", error);
            setDepartments([]);
            setShiftList([]);
        }

        // ✅ Update filters
        setFilters(prev => ({ ...prev, PlantName: plantId }));
    };

    const handleDepartmentChange = (e) => {
        const deptId = e.target.value;
        setSelectedDepartment(deptId);
        setFilters(prev => ({ ...prev, DepartmentName: deptId }));
    };
    const handleShowHistory = async (empCode) => {
        try {
            debugger;
            setLoading(true);
            setHistoryEmpCode(empCode);
             const res = await EmployeeProcessService.getEmployeeShift({
                ...filters,
                EmployeeCode: empCode || "" ,  // ✅ employee code filter
                Mode:"ShiftHistory"
            });

            if (res.data.statusCode === 200 && res.data.result.length > 0) {
                setHistoryData(res.data.result);
            } else {
                setHistoryData([]);
            }
            setShowHistory(true);
        } catch (error) {
            console.error("Error fetching shift history:", error);
            alert("Failed to load shift history.");
        } finally {
            setLoading(false);
        }
    };
    const handleLoadEmployees = async () => {
        if (!filters.PlantName) {
            alert("Please select  Plant .");
            return;
        }
        // if (!filters.DepartmentName) {
        //     alert("Please select  Department.");
        //     return;
        // }

        try {
            const res = await EmployeeProcessService.getEmployeeShift({
                ...filters,
                EmployeeCode: searchCode || "" ,  // ✅ employee code filter
                 Mode:"ShiftGet"
            });

            if (res.data.statusCode === 200) {
                setEmployees(res.data.result);
                setSelectedEmployees([]);
                setSelectAll(false);
            } else {
                setEmployees([]);
            }
        } catch (err) {
            console.error("Error loading employees:", err);
            setEmployees([]);
        }
    };

    const handleSelectEmployee = (employeeCode) => {
        if (selectedEmployees.includes(employeeCode)) {
            setSelectedEmployees(selectedEmployees.filter(code => code !== employeeCode));
        } else {
            setSelectedEmployees([...selectedEmployees, employeeCode]);
        }
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedEmployees([]);
        } else {
            setSelectedEmployees(employees.map(emp => emp.empCode));
        }
        setSelectAll(!selectAll);
    };

    const handleSubmit = async () => {
        if (!selectedShift || !startDate || !endDate || selectedEmployees.length === 0) {
            alert("Please fill all required fields and select employees.");
            return;
        }
        setLoading(true);
        try {
            const payload = {
                EmpCode: selectedEmployees.join(','),
                ShiftID: selectedShift,
                StartDate: startDate,
                EndDate: endDate
            };

            const res = await EmployeeProcessService.setEmployeeShift(payload);
            //debugger;
            if (res.success === true) {
                alert("Shifts assigned successfully.");
                setSelectedEmployees([]);
                setSelectAll(false);
            } else {
                const message = res.errorMessage || 'Submission failed. Please try again.';
                alert(message);
            }
        } catch (error) {
            const message = error?.message || 'Unexpected error occurred.';
            alert(message);
            console.error("Unhandled error:", message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container">
            <h4 className="text-primary mb-3">Shift Allocation</h4>

            <div className="row mb-3">
                <div className="col-md-3">
                    <label className="text-primary">Plant</label>
                    <select
                        className="form-select"
                        value={selectedPlant}
                        onChange={handlePlantChange}
                        required
                    >
                        <option value="">-- Select Plant --</option>
                        {plantList.map(plant => (
                            <option key={plant.id} value={plant.id}>{plant.name}</option>
                        ))}
                    </select>
                </div>
                <div className="col-md-3">
                    <label className="text-primary">Department</label>
                    <select
                        className="form-select"
                        value={selectedDepartment}
                        onChange={handleDepartmentChange}
                        required
                    >
                        <option value="">-- Select Department --</option>
                        {departments.map(dept => (
                            <option key={dept.id} value={dept.id}>{dept.name}</option>
                        ))}
                    </select>
                </div>
                <div className="col-md-3">
                    <label className="text-primary"> Employee Code Comma Separeted</label>
                    <input
                        type="text"
                        className="form-control"
                        value={searchCode}
                        onChange={(e) => setSearchCode(e.target.value)}
                        placeholder="Enter Employee Code"
                    />
                </div>
                <div className="col-md-2 d-flex align-items-end">
                    <button
                        className="btn btn-primary"
                        onClick={handleLoadEmployees}
                    >
                        Load Employees
                    </button>
                </div>
            </div>

            {employees.length > 0 && (
                <>
                    <div style={{ overflowX: 'auto', maxHeight: '350px' }}>
                        <table className="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            checked={selectAll}
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                    <th>User Code</th>
                                    <th>Name</th>
                                    <th>Department</th>
                                    <th>Default ShiftName</th>
                                    {/* <th>Default StartDate</th>
                                    <th>Default EndDate</th> */}
                                    <th>Assigned Shift</th>
                                </tr>
                            </thead>
                            <tbody>
                                {employees.map(emp => (
                                    <tr key={emp.empCode}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedEmployees.includes(emp.empCode)}
                                                onChange={() => handleSelectEmployee(emp.empCode)}
                                            />
                                        </td>
                                        <td>{emp.empCode}</td>
                                        <td>{emp.empName}</td>
                                        <td>{emp.department}</td>
                                        <td>{emp.shiftName}</td>
                                        {/* <td>{emp.startDate}</td>
                                        <td>{emp.endDate}</td> */}
                                        <td>
                                            <button
                                                className="btn btn-link p-0"
                                                onClick={() => handleShowHistory(emp.empCode)}
                                            >
                                                View
                                            </button> </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label>Shift</label>
                            <select
                                className="form-select"
                                value={selectedShift}
                                onChange={(e) => setSelectedShift(e.target.value)}
                                required
                            >
                                <option value="">-- Select Shift --</option>
                                {shiftList.map(shift => (
                                    <option key={shift.id} value={shift.id}>{shift.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label>Shift Start Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            //min={new Date().toISOString().split('T')[0]}
                            //required
                            />
                        </div>
                        <div className="col-md-3">
                            <label>Shift End Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            //min={new Date().toISOString().split('T')[0]}
                            //required
                            />
                        </div>
                        <div className="col-md-2 d-flex align-items-end">
                            <button className="btn btn-success" onClick={handleSubmit}>
                                Submit
                            </button>
                        </div>
                    </div>

                    {showHistory && (
                        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.4)' }}>
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title text-primary">
                                            Shift History - {historyEmpCode}
                                        </h5>
                                        <button type="button" className="btn-close" onClick={() => setShowHistory(false)}></button>
                                    </div>
                                    <div className="modal-body">
                                        {historyData.length > 0 ? (
                                            <table className="table table-bordered table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>Shif Name</th>
                                                        <th>Start Date</th>
                                                        <th>End Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {historyData.map((row) => (
                                                        <tr key={row.ID}>
                                                            <td>{row.shiftName}</td>
                                                            <td>{row.startDate}</td>
                                                            <td>{row.endDate}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <p>No shift history found in the last 2 months.</p>
                                        )}
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-secondary" onClick={() => setShowHistory(false)}>
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default ShiftAllocation;
